import AgentsContainer from './agents-container';

export default AgentsContainer;
